import axiosInstance from './axios.js';

const fetchMiniList = async(url) => {
  try {
    const response = await axiosInstance.get(url);
    return {status: true, data: response.data}
  } catch (error) {
    console.error(`Cannot fetch list from: ${url}`);
    console.error(`${error}`);
    return {status: false, data: "Cannot fetch data"};
  }
}

export default fetchMiniList;
